import type { QueryClient } from '@tanstack/react-query';
import { isAccessRefused } from '../domain/access-refusal';

/** After a refusal nothing of the group's chat may stay cached to be shown again. */
export function evictGroupChatOnRefusal(
  queryClient: QueryClient,
  viewerId: string,
  groupId: string,
  error: Error,
) {
  if (isAccessRefused(error)) {
    queryClient.removeQueries({ queryKey: ['group-chat', viewerId, groupId] });
  }
}
